
export default ({ request }) => ({
 get_roles(params) {
    return request({
      url: '/v1/roles/list',
      method: 'get',
      params
    })
  },
  get_role(id) {
    return request({
      url: `/v1/roles/${id}`,
      method: 'get'
    })
  },
  update_role(id, data) {
    return request({
      url: `/v1/roles/${id}`,
      method: 'put',
      data: data
    })
  },
  save_role(data) {
    return request({
      url: '/v1/roles',
      method: 'post',
      data
    })
  },
  // 新增：获取所有角色列表（超级管理员专用）
  get_all_roles() {
    return request({
      url: '/v1/roles/all',
      method: 'get'
    })
  },
  // 新增：获取当前租户角色列表
  get_current_tenant_roles() {
    return request({
      url: '/v1/roles/current-tenant',
      method: 'get'
    })
  },
  // 新增：获取所有可用权限树（用于角色编辑时选择权限）
  get_available_permissions_tree() {
    return request({
      url: '/v1/roles/available-permissions/tree',
      method: 'get'
    })
  },
  // 新增：获取所有可用权限列表（扁平结构，用于角色编辑时选择权限）
  get_available_permissions_list() {
    return request({
      url: '/v1/roles/available-permissions/list',
      method: 'get'
    })
  }
})
